// Swak Custom - 追従LINEアイコン
import { Component } from '@theme/component';

/**
 * 追従LINEアイコンコンポーネント
 * 画面に固定表示されるLINE公式アカウント誘導アイコン
 * 
 * @extends {Component}
 */
class SwakStickyLineIcon extends Component {
  static STORAGE_KEY = 'swak_sticky_line_bubble_closed';

  connectedCallback() {
    this.bubble = this.querySelector('[data-bubble]');
    this.closeButton = this.querySelector('[data-bubble-close]');

    if (!this.bubble) return;

    // セッションストレージで閉じた状態を確認
    if (sessionStorage.getItem(SwakStickyLineIcon.STORAGE_KEY) === 'true') {
      this.bubble.style.display = 'none';
      return;
    }

    // 閉じるボタンのイベントリスナー
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClose);
    }
  }

  disconnectedCallback() {
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.handleClose);
    }
  }

  handleClose = (event) => {
    event.preventDefault();
    event.stopPropagation();

    // 吹き出しを非表示
    if (this.bubble) {
      this.bubble.style.display = 'none';
    }

    // セッションストレージに保存
    sessionStorage.setItem(SwakStickyLineIcon.STORAGE_KEY, 'true');
  };
}

// カスタム要素として登録
if (!customElements.get('swak-sticky-line-icon')) {
  customElements.define('swak-sticky-line-icon', SwakStickyLineIcon);
}

// /Swak Custom - 追従LINEアイコン
